/* eslint-disable padding-line-between-statements */
/* eslint-disable unicorn/filename-case */
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

/**
 * Get Address value
 * @param address
 * @returns {*}
 */
const getAddressValue = (address) => {
    const retAddress = address.value || address;
    return retAddress;
};

export default class AddressStandardizationServiceCC {
    
    static getCCPortalConstants(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('constantscc'),
            'getConstants',
            [],
            additionalHeaders
        );
    };

    static findStandardizedAddressesCC(anAddress, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('addressstandardization'),
            'findStandardizedAddresses',
            [getAddressValue(anAddress)],
            additionalHeaders
        );
    };

    static pickStandardizedAddressCC(pickedAddress, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('addressstandardization'),
            'pickStandardizedAddress',
            [getAddressValue(pickedAddress)],
            additionalHeaders
        );
    }
}